
<canvas ref="lineChart"></canvas>
  
<script>
  import { Line } from 'vue-chartjs'
  
  export default {
    name: 'TrafficLineChart',
    extends: Line,
    props: {
        labels: { type: Array, default: () => [] },
        datasets: { type: Array, default: () => [] }
    },
    mounted() {
        this.drawChart()
    },
    watch: {
        labels: 'drawChart',
        datasets: {
            handler: 'drawChart'
        }
    },
    methods: {
        drawChart(){
            this.renderChart({
                labels: this.labels,
                datasets: this.datasets
            }, {
                responsive: true,
                maintainAspectRatio: false
            })
        }
    }
  }
  </script>
  
  <style scoped>
  div, canvas {
    min-height: 280px;
  }
</style>